<div class="shift-header-v4" [ngClass]="{'is-training': showTrainingStyle, 'is-previous': previousShiftView}">
    <div class="header-main-info">
        <div class="status-indicator" [class.broadcast]="jobItem?.isABroadcastRequest?.isTrue">
            <i class="fas" [ngClass]="jobItem?.isABroadcastRequest?.isTrue ? 'fa-broadcast-tower' : 'fa-user-tie'"></i>
            <span>{{ (jobItem?.isABroadcastRequest?.isTrue ? (jobItem?.isVisitBasedShift ? 'Visit Request' : 'Shift Request') : 'Direct Hire') }}</span>
        </div>
        <h1 class="skill-title">{{ ('SKILLS.' + jobItem.skill) | translate }}</h1>
        <div class="header-actions-inline" *ngIf="state !== 'ongoing-shifts' && !previousShiftView">
            <button class="minimal-btn edit" (click)="handleEditShift($event)"><i class="fas fa-pencil-alt"></i> Edit</button>
            <button class="minimal-btn delete" (click)="handleDeleteShift()"><i class="fas fa-trash"></i> Delete</button>
        </div>
    </div>

    <div class="header-datetime-block">
        <!-- Single Day Display -->
        <div class="date-display" *ngIf="jobItem.jobs.length === 1">
            <div class="calendar-page">
                <span class="month">{{jobItem.shiftStartTime | momentPipeUnix:'MMM'}}</span>
                <span class="day">{{jobItem.shiftStartTime | momentPipeUnix:'DD'}}</span>
            </div>
            <div class="date-details">
                <span class="day-name">{{jobItem.shiftStartTime | momentPipeUnix:'dddd'}}</span>
                <span class="shift-count">Single Shift</span>
            </div>
        </div>

        <!-- Multi-Day Display -->
        <div class="date-display multi-day" *ngIf="jobItem.jobs.length > 1">
            <div class="calendar-range-group">
                <div class="calendar-page small">
                    <span class="month">{{jobItem.shiftStartTime | momentPipeUnix:'MMM'}}</span>
                    <span class="day">{{jobItem.shiftStartTime | momentPipeUnix:'DD'}}</span>
                </div>
                <div class="range-arrow"><i class="fas fa-long-arrow-alt-right"></i></div>
                <div class="calendar-page small">
                    <span class="month">{{jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'MMM'}}</span>
                    <span class="day">{{jobItem.jobs[jobItem.jobs.length - 1].shiftStartTime | momentPipeUnix:'DD'}}</span>
                </div>
            </div>
            <div class="date-details">
                <span class="day-name">{{jobItem.jobs.length}} Total Shifts</span>
                <span class="shift-count">Multi-day Request</span>
            </div>
        </div>

        <div class="time-display" *ngIf="!jobItem.isVisitBasedShift">
            <i class="far fa-clock"></i>
            
            <!-- Single Shift OR Multi-shift with same timings -->
            <span class="time-range" *ngIf="jobItem.jobs.length === 1 || hasSimilarTimings">
                {{jobItem.shiftStartTime | momentPipeUnix:'hh:mma'}} - {{jobItem.shiftEndTime | momentPipeUnix:'hh:mma'}}
                <span class="view-schedule-link" *ngIf="jobItem.jobs.length > 1" (click)="handleViewMultipleTimings($event)">
                    (View Schedule)
                </span>
            </span>

            <!-- Multi-shift with DIFFERENT timings -->
            <span class="time-range clickable" *ngIf="jobItem.jobs.length > 1 && !hasSimilarTimings" (click)="handleViewMultipleTimings($event)">
                Multiple Timings <i class="fas fa-external-link-alt"></i>
            </span>
        </div>
        <div class="time-display" *ngIf="jobItem.isVisitBasedShift">
            <i class="fas fa-handshake"></i>
            <span class="time-range">Visit Based</span>
        </div>
    </div>
</div>
